import { Component, h, Host } from "@stencil/core";

/**
 * @slot (default) - insert the content of the various form step, only supported
 * form elements of the ux-form component will be validated by it.
 */

let formStepCounter = 0;

@Component({
    tag: "ux-form-step",
    styleUrl: "form-step.scss"
})
export class FormStep {
    private baseClass = "ux-form-step";
    private formStepTabId = `ux-form-step-tab-${formStepCounter++}`;

    render() {
        return (
            <Host class={this.baseClass}>
                <ux-tab tab-id={this.formStepTabId} name={this.formStepTabId}>
                    <slot />
                </ux-tab>
            </Host>
        );
    }
}
